import { CookieService } from 'ngx-cookie-service';
import { ModulesService } from './tools/modules.service';
import { Router } from '@angular/router';
import { Http, Headers, RequestOptions } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class AutenticacionService {

  public auth_user;
  public auth_token;
  private service_url;
  constructor(private constantsService: ConstantsService,
    private http: Http,
    private router: Router,
    private modulesService: ModulesService,
    private cookieService: CookieService) {
    this.service_url = this.constantsService.apiURL;
    //this.startAuth();
  }
  //Definir el puente entre el frond y la api
  public login(username, password) {
    const data = {
      'username': username,
      'password': password
    };

    return this.http.post(this.service_url + '/login', data);
  }

  public setUser(content) {
    const secure = this.constantsService.apiURL.indexOf("https") != -1;
    const sameSite = "Lax";

    if(content == undefined) {
      this.auth_user = undefined; // reseting auth user
      this.auth_token = undefined; // reseting auth token
      this.cookieService.delete('ark-token'); // when receive content on undefined, It's means we want to refresh out cookie
      this.cookieService.delete('user-rol');
    } else {
      // saving auth local user
      this.auth_user = content.user;
      if (content.token) { // when we receive token override the cookie

        this.cookieService.set('ark-token', content.token.access_token, undefined, undefined, undefined, secure, sameSite);
        this.auth_token = content.token;
      } else if (!content.token && !this.getToken()) { // when we don't receive token and we don't have token on our cookie, send to login
        this.router.navigate(['login']);
      } else { // when we don't receive token, It's means we have the token on cookie
        this.auth_token = this.getToken();
      }

      //Guardar en una cookie el rol del usuario
      if(content.user && content.user.usuarios_permisos){
        this.cookieService.set('user-rol', content.user.usuarios_permisos.descripcion.toLowerCase(), undefined, undefined, undefined, secure, sameSite);
      }
    }
  }

  startAuth() {
    const token = this.getToken();

    if (token && !this.auth_token) {
      this.getUser().subscribe(response => {
        const content = response.json().content;
        this.setUser(content);
      }, error => {
        console.log('startAuth - error ', error);
      });
    }
  }

  killUser() {
    this.setUser(undefined);
    this.router.navigate(['login']);
  }

  closeKey() {
    return this.http.delete(this.service_url + '/logoutKey', this.getAuthHeaders());
  }

  getUser() {
    return this.http.get(this.service_url + '/datosUsuario', this.getAuthHeaders());
  }

  getToken() {
    return this.cookieService.get('ark-token');
  }

  public getAuthHeaders() {
    const token = this.getToken();
    if(!token) {
      this.router.navigate(['login']);
    }

    const requestOptions = new RequestOptions({
      'headers': new Headers({
        'Authorization': 'Bearer ' + token,
      })
    });

    return requestOptions;
  }

  public getHttpClientHeaders() {
    const token = this.getToken();
    if(!token) {
      this.router.navigate(['login']);
    }

    let headers = new HttpHeaders();

    headers = headers.set('Authorization', 'Bearer ' + token)

    return headers;
  }

  recuperarPassword(username) {
    const data = {
      'username': username
    }
    return this.http.post(this.service_url + '/recover', data);
  }

  generarPassword(token, old_password, new_password) {
    const data = {
      'token': token,
      'old_password': old_password,
      'new_password': new_password
    };
    return this.http.post(this.service_url + '/change', data);
  }

  logout() {
    return this.http.post(this.service_url + '/logout',{}, this.getAuthHeaders());
  }

  // receive a permission id, example 1
  hasPermission(permissionId, read = false) {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return false;
    }

    const permission = (read)?'escritura': 'lectura'; // if the second parameter of our function is true, we want to filter write permition
    let hp = false; //haspermissions
    this.auth_user.permisos_usuarios.forEach(p => {
      if (permissionId == p.idPermisos && (p[permission] == 1 || p[permission] == true)) {
        hp = true;
      }
    });

    return true;
  }

  // receive a array with id of permission, example: [1,2,3]
  hasPermissions(permissionsIds, read = false) {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return false;
    }

    let hp = false; //haspermissions
    const permission = (read)?'escritura': 'lectura'; // if the second parameter of our function is true, we want to filter write permition
    this.auth_user.permisos_usuarios.forEach(permiso_usuario => {
      permissionsIds.forEach(permisos_seccion => {
        if (permisos_seccion == permiso_usuario.idPermisos && (permiso_usuario[permission] == 1 || permiso_usuario[permission] == true)) {
        hp = true;
      }
      });
    });

    return hp;
  }


  canExport() {
    if (!this.auth_user) {
      return false;
    }
    const canExport = (this.auth_user.exportacion == 1)?true:false;
    return canExport
  }

  canSecurity() {
    if (!this.auth_user) {
      return false;
    }
    const canSecurity = (this.auth_user.cuentas == 1)?true:false;
    return canSecurity;
  }

  getFirstPermittedRoute() {
    const token = this.getToken();
    if(!token || !this.auth_user) {
      return 'login';
    }

    let first_permitted = undefined;
    this.auth_user.permisos_usuarios.forEach(p => {
      if (!first_permitted && (p.lectura == 1 || p.lectura == true)) {
        first_permitted = p;
      }
    });

    const module = this.modulesService.find(first_permitted.idPermisos)
    let path = 'login';
    if (module.path) {
      path = module.path;
    } else {
      this.killUser();
      console.log('we dont have a module enable so redirecto to login');
    }
    return path;
  }

  public isAdmin(){
    let userRol =this.cookieService.get('user-rol');
    return userRol === 'administrador';
  }

  public isExecutive(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'ejecutivo';
  }
  public isUser(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'usuario';
  }

  public isGestorGastos(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'gestor de gastos';
  }

  public isFondeador(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'fondeador';
  }

  public isEjecutivoFondeador(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'ejecutivo fondeador';
  }

  public isEjecutivoReportero(){
    let userRol = this.cookieService.get('user-rol');
    return userRol === 'ejecutivo de reportes';
  }

  public isCobranza() {
  let userRol = this.cookieService.get('user-rol');
  return userRol === 'cobranza'; // O el nombre que prefieras asignar al ID 10
}

// En autenticacion.service.ts

// Añade este método al final de la clase
public getNombreUsuario() {
  // Si la variable en memoria existe, la usamos
  if (this.auth_user && this.auth_user.email) {
    return this.auth_user.email;
  }
  // Si no (por ejemplo tras un F5), podrías intentar recuperarlo de donde guardes el objeto completo
  // O retornar un valor por defecto si auth_user es undefined
  return 'Usuario'; 
}
}



// WEBPACK FOOTER //
// ./src/app/services/autenticacion.service.ts